import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { PatientModel, PatientReminderModel } from '../../../core/api/models';
import { SupervisorApiService } from '../../../core/api/services';
import { SupervisorHelperService } from '../../supervisor.helper.service';
import { AlertService } from '../../../shared/services/alert.service';
import { Utils } from '../../../core/utils';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { formatDate } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-add-reminder',
  templateUrl: './add-reminder.component.html',
  styleUrl: './add-reminder.component.css',
  standalone: false,
})
export class AddReminderComponent {
  @Input({ required: true }) selectedPatient!: PatientModel;
  reminderToEdit: PatientReminderModel | null = null;

  @Output() close = new EventEmitter<boolean>();

  loading: boolean = false;

  titleName: string = 'Add Reminder';
  actionName: string = 'Add';

  reminderId: number | null = null;
  name = '';
  message = '';
  interval = 0;

  reminderOptions: {label: string, value: string}[] = [
    {label: "Select", value: ""},
    {label: "Monthly", value: "Monthly"},
    {label: "Weekly", value: "Weekly"},
    {label: "Daily", value: "Daily"},
  ];

  showDayOptions: boolean = false;
  showWeekOptions: boolean = false;

  monday: boolean = false;
  tuesday: boolean = false;
  wednesday: boolean = false;
  thursday: boolean = false;
  friday: boolean = false;
  saturday: boolean = false;
  sunday: boolean = false;

  weekOptions:  {label: string, value: number | null | undefined}[] = [
    {label: "First", value: 1},
    {label: "Second", value: 2},
    {label: "Third", value: 3},
    {label: "Fourth", value: 4},
  ];

  showInterval: boolean = false;
  Time?: any | null = null;
  TimeString?: string | null = "";
  doRepeat: boolean = false;
  selectedReminderOption: string | null | undefined = null;
  weekOfMonth: number | null | undefined = null;
  constructor(
    private supervisorApiService: SupervisorApiService,
    private supervisorHelperService: SupervisorHelperService,
    private alertService: AlertService,
  ) {}

  ngOnInit(): void {
    // EDIT LOGIC
    if (this.supervisorHelperService.reminderToEdit() != null) {
      this.titleName = 'Edit Reminder';
      this.actionName = 'Save';
      this.reminderToEdit = this.supervisorHelperService.reminderToEdit();
      this.reminderId = this.reminderToEdit?.ID ?? 0;
      this.name = this.reminderToEdit?.Name ?? '';
      this.message = this.reminderToEdit?.Message ?? '';
      this.interval = this.reminderToEdit?.Interval ?? 0;
      this.doRepeat = this.reminderToEdit?.DoRepeat ?? false;
      this.weekOfMonth = this.reminderToEdit?.WeekOfMonth ?? null;
      if (this.reminderToEdit?.Type != null && this.reminderToEdit?.Type != ""){
        if(this.reminderToEdit?.Type == "Monthly"){
          this.showWeekOptions = true;
          this.showDayOptions = true;
        }
        if(this.reminderToEdit?.Type == "Weekly"){
          this.showDayOptions = true;
        }
        this.selectedReminderOption = this.reminderToEdit?.Type;
      }
      if(this.reminderToEdit?.Time != null){
        this.Time = new Date(this.reminderToEdit?.Time);
        this.TimeString = this.formatDate(this.reminderToEdit?.Time)
      }
      if(this.reminderToEdit?.DoRepeat == true){
        this.showInterval = true;
      }
      if(this.reminderToEdit?.Days != null && this.reminderToEdit?.Days != "" ){
        this.updateDaysUI(this.reminderToEdit?.Days);
      }
    }
  }

 updateDaysUI(days: string | null | undefined): void {
   if( days?.includes("Monday")){
    this.monday = true;
   }
   if( days?.includes("Tuesday")){
    this.tuesday = true;
   }
   if( days?.includes("Wednesday")){
    this.wednesday = true;
   }
   if( days?.includes("Thursday")){
    this.thursday = true;
   }
   if( days?.includes("Friday")){
    this.friday = true;
   }
   if( days?.includes("Saturday")){
    this.saturday = true;
   }
   if( days?.includes("Sunday")){
    this.sunday = true;
   }
 }

  onCancel() {
    this.close.emit(false);
  }

  formatDate(date: string | Date | null | undefined): string | null {
    if (!date) return null;
    return formatDate(date, 'dd/MM/YYYY HH:mm aa', 'en-US');
  }

  onSubmit() {
    var days = "";
    if(this.monday == true){
      days += "Monday,";
     }
    if(this.tuesday == true){
      days += "Tuesday,";
     }
    if(this.wednesday == true){
      days += "Wednesday,";
     }
    if(this.thursday == true){
      days += "Thursday,";
     }
    if(this.friday == true){
      days += "Friday,";
     }
    if(this.saturday == true){
      days += "Saturday,";
     }
    if(this.sunday == true){
      days += "Sunday,";
     }

    if (!this.name?.trim()) {
      return this.alertService.error('Please enter a reminder name');
    }
    if (!this.message?.trim()) {
      return this.alertService.error('Please enter a reminder message');
    }
    if(this.selectedReminderOption == "Monthly"){
      if(days == null || days == ""){
        return this.alertService.error("Please select the days of the week to trigger the reminder");
      }
      if(!this.weekOfMonth || this.weekOfMonth == null || this.weekOfMonth == 0 ){
        return this.alertService.error("Please select which week of the month to trigger reminder");
      }
    }
    if(this.selectedReminderOption == "Weekly"){
      if(days == null || days == ""){
        return this.alertService.error("Please select the days of the week to trigger the reminder");
      }
    }
    if (this.selectedReminderOption == null || this.selectedReminderOption == ""){
      return this.alertService.error("Please select reminder type");
    }
    if (this.Time == null || this.Time == ""){
      return this.alertService.error("Please select what time you would like to trigger the reminder");
    }
    this.loading = true;

    const localISOString = this.Time.toISOString();

    var data = {
      ID: this.reminderId,
      Interval: this.interval,
      Message: this.message,
      Name: this.name,
      PatientID: this.selectedPatient?.ID,
      TimeString: localISOString,
      Time: localISOString,
      DoRepeat: this.doRepeat,
      Days: days,
      Type: this.selectedReminderOption,
      WeekOfMonth: this.weekOfMonth,
    }

    this.supervisorApiService
      .SavePatientReminder({
        body: data,
      }).subscribe(
        (reminder) => {
          console.log(reminder);
          this.loading = false;
          this.alertService.success('Reminder saved successfully');
          this.close.emit(true);
        },
        (error) => {
          console.error(error);
          this.alertService.error(
            Utils.getErrorMessageFromErrorResponse(error)
          );
          this.loading = false;
          this.close.emit(false);
        }
      );
  }

  changedReminderType(event: DropdownChangeEvent): void {

    if(event.value == "Monthly"){
      this.showDayOptions = true;
      this.showWeekOptions = true;
    }
    else if(event.value == "Weekly"){
      this.showWeekOptions = false;
      this.showDayOptions = true;
    }
    else{
      this.monday = false;
      this.tuesday = false;
      this.wednesday = false;
      this.thursday = false;
      this.friday = false;
      this.saturday = false;
      this.sunday = false;
      this.weekOfMonth = null;
      this.showDayOptions = false;
      this.showWeekOptions = false;
    }
    this.selectedReminderOption = event.value;
  }

  changedWeekType(event: DropdownChangeEvent): void {
    this.weekOfMonth = event.value;
  }

  testCalendar(data: any): void {
    this.TimeString = this.formatDate(data);
  }

  toggleInterval(): void {
    this.showInterval = !this.showInterval;
  }
}
